import { useEffect, useState } from "react";
import { cropImage } from "../../../../utils/format";
import style from "../rodingenerateboard.module.css";
import { ImageOverlay } from "../../../../common/ImageOverlay";
import { useTranslation } from "react-i18next";

const SymmetricalTip = ({ imgUrl }) => {
    const [imgSrc, setImgSrc] = useState([])
    const { t } = useTranslation();

    useEffect(() => {
        const init = async () => {
            // const downloadPromises =  downloadImage(imgUrl)
            // const downloaded = await Promise.resolve(downloadPromises);
            // console.log(downloadPromises,);
            const queryUrls = await Promise.all([cropImage(imgUrl, 360, 360, 0), cropImage(imgUrl, 360, 360, 16)]);
            setImgSrc(queryUrls)
        }
        if (imgUrl) {
            init()
        }
    }, [imgUrl])

    // async function downloadImage(imageUrl) {
    //     const response = await fetch(imageUrl);
    //     const blob = await response.blob();

    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => resolve(reader.result);
    //         reader.onerror = reject;
    //         reader.readAsDataURL(blob);
    //     });
    // }

    return (
        <div
            className={`${style.symmetricalTip}`}>
            <div className={style.symmetricalContent}>
                <span className={style.symmetricalInfo}>
                    {t('RODIN_GENERTAE_BOARD_GEO_SYM_TITLE')}?
                </span>
                <div className={style.symmetricalImg}>
                    {(imgSrc.length ? imgSrc : ['demo1', 'demo2']).map((item, index) => {
                        return (
                            <div className={style.symmetricalImgBox} key={index} >
                                <ImageOverlay
                                    src={item}
                                    alt='symmetrical image' />
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className={style.polygonSpaceHodler}></div>
        </div>
    )
}

export { SymmetricalTip }